import {
  Card,
  Text,
  Textarea,
  Input,
  SimpleGrid,
  Group,
  Button,
  Modal,
} from '@mantine/core';
import { DatePickerInput, type DateValue } from '@mantine/dates';
import { useClientIPPFormContext } from '../ClientIppSection';
import dayjs from 'dayjs';
import { dateFormat } from '@/index';

export const OtherInfoCard: React.FC = () => {
  const form = useClientIPPFormContext();

  return (
    <Card shadow="sm" radius="md" withBorder>
      <SimpleGrid verticalSpacing="sm">
        <Group justify="space-between">
          <Text fw={700} size="lg">
            Další
          </Text>
        </Group>

        <DatePickerInput
          label="Datum příští revize"
          variant="filled"
          radius="md"
          valueFormat={dateFormat}
          value={dayjs(form.values.nextRevDate, dateFormat).toDate()}
          onChange={(d: DateValue) => {
            form.setFieldValue('nextRevDate', dayjs(d).format(dateFormat));
          }}
          error={form.errors?.nextRevisionDate}
        />
        <DatePickerInput
          label="Datum poslední revize"
          variant="filled"
          radius="md"
          valueFormat={dateFormat}
          value={dayjs(form.values.lastRevDate, dateFormat).toDate()}
          onChange={(d: DateValue) => {
            form.setFieldValue('lastRevDate', dayjs(d).format(dateFormat));
          }}
          error={form.errors?.lastRevisionDate}
        />
        <DatePickerInput
          label="Platnost smlouvy"
          variant="filled"
          radius="md"
          valueFormat={dateFormat}
          value={dayjs(form.values.expDate, dateFormat).toDate()}
          onChange={(d: DateValue) => {
            form.setFieldValue('expDate', dayjs(d).format(dateFormat));
          }}
          error={form.errors?.expDate}
        />
        <DatePickerInput
          label="Datum sestavení IPP"
          variant="filled"
          radius="md"
          valueFormat={dateFormat}
          value={dayjs(form.values.createdAt, dateFormat).toDate()}
          onChange={(d: DateValue) => {
            const date: string = dayjs(d).format(dateFormat);
            form.setFieldValue('createdAt', date);
          }}
          error={form.errors?.createdAt}
          disabled
        />

        <Input.Wrapper label="Další skutečnosti a poznámky">
          <Textarea
            variant="filled"
            radius="md"
            placeholder="Prázdná poznámka..."
            autosize
            {...form.getInputProps('note')}
            data-testid="note-input"
          />
        </Input.Wrapper>
      </SimpleGrid>
    </Card>
  );
};
